// extracted by mini-css-extract-plugin
export default {"waves":"Waves_waves__oA5WJ","parallax":"Waves_parallax__wtsdV","move-forever":"Waves_move-forever__Q6RUr"};